import { render, staticRenderFns } from "./basicPage.vue?vue&type=template&id=65c5a1c9&scoped=true&"
import script from "./basicPage.vue?vue&type=script&lang=ts&"
export * from "./basicPage.vue?vue&type=script&lang=ts&"
import style0 from "./basicPage.vue?vue&type=style&index=0&id=65c5a1c9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c5a1c9",
  null
  
)

export default component.exports